import { useRef, useEffect } from "react";
import { States } from "../App";
import { ListItem } from "../elements/ListItem";

export function EditSpinnerPage({
  spinnerEntries,
  addNewEntry,
  deleteEntry,
  toggleEntryVisible,
  setState,
  hideCheckedEntries,
}) {
  const expectToScrollRef = useRef(false);

  useEffect(() => {
    if (expectToScrollRef.current) {
      const valueList = document.getElementById("edit-spinner-page-list");
      if (valueList) {
        valueList.scrollTo(0, valueList.scrollHeight);
      }
      expectToScrollRef.current = false;
    }
  }, [spinnerEntries, expectToScrollRef]);

  const valueList = [];
  for (const i in spinnerEntries) {
    if (hideCheckedEntries && !spinnerEntries[i].visible) {
      continue;
    }

    const style = {};
    if (!spinnerEntries[i].visible) {
      style.color = "darkred";
      style.textDecoration = "line-through";
    }

    valueList.push(
      <ListItem
        key={i}
        buttonImg="cross.png"
        buttonOnClick={() => {
          deleteEntry(spinnerEntries[i].id);
        }}
        textOnClick={() => {
          toggleEntryVisible(spinnerEntries[i].id);
        }}
        text={spinnerEntries[i].entry}
        style={style}
      />,
    );
  }

  function submitAddNewValue() {
    const value = document.getElementById("new-value-input").value;
    if (value) {
      addNewEntry(value);
      document.getElementById("new-value-input").value = "";
    }
    expectToScrollRef.current = true;
  }

  return (
    <div
      className="sidecontent EditSpinnerPage"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          submitAddNewValue();
        } else if (e.key === "Escape") {
          setState(States.SpinTheWheel);
        }
      }}
    >
      <div className="list" id="edit-spinner-page-list">
        {valueList}
      </div>
      <div className="inputandbutton">
        <input
          placeholder="Enter new value here"
          id="new-value-input"
          autoComplete="off"
        ></input>
        <button onClick={submitAddNewValue}>Add</button>
      </div>
    </div>
  );
}
